import { css } from 'styled-components'
import transformProps from '../utils/transformProps'
import { ConfigType, Dictionary, StyleType } from '../utils/transformProps/types'

type PositioningKey = 'position'

type ZIndexKey = 'zIndex'

type BasicPositionKeys = 'top' | 'left' | 'right' | 'bottom'

export type PositionKeys = PositioningKey | ZIndexKey | BasicPositionKeys

type PositioningProp = {
    [key in PositioningKey]?: string | string[]
}

type ZIndexProp = {
    [key in ZIndexKey]?: number | number[]
}

export type PositionProps = PositioningProp &
    ZIndexProp & {
        [key in BasicPositionKeys]?: Dictionary
    }

const positionConfig: ConfigType<PositionKeys> = {
    position: {
        property: ['position'],
    },
    zIndex: {
        property: ['zIndex'],
    },
    top: {
        property: ['top'],
    },
    left: {
        property: ['left'],
    },
    right: {
        property: ['right'],
    },
    bottom: {
        property: ['bottom'],
    },
}

export const position = css<PositioningProp>`
    ${(props): StyleType => transformProps(positionConfig, props)}
`
